
export type ProjectModel = {
  id: string;
  key: string;
  category: Category;
  title: string;
  description: string;
  longDescription?: string;
  coverImage: string;
  images: Array<string>;
  framework: Framework;
  keywords: Array<string>;
  url?: Array<string>;
  createdDate: string;
  latestUpdate: string;
  isDeactive?: boolean;
};

export type Category = {
  name: string;
  key: string;
};

export type Framework = {
  name: string;
  icon: string;
  key: string;
  svg?: string;
};

function generateLabel(key: string) {
  return `${key.substring(0, 1).toUpperCase()}${key.substring(1)}`;
}

export const ProjectModelFromJson = (key: string, json: any) => {
  const category: Category = {
    name: `${generateLabel(json["category"])}`,
    key: json["category"],
  };

  const framework: Framework = {
    name: `${generateLabel(json["framework"])}`,
    icon: `${json["framework"]}.png`,
    key: json["framework"],
    svg: `${json["framework"]}.svg`
  };

  const data: ProjectModel = {
    id: key,
    key: json["key"],
    category: category,
    title: json["title"],
    description: json["description"],
    longDescription: json["longDescription"],
    coverImage: json["coverImage"],
    images: json["images"],
    framework: framework,
    keywords: json["keywords"],
    url: json["url"],
    createdDate: json["createdDate"],
    latestUpdate: json["latestUpdate"],
    isDeactive: json["isDeactive"],
  };

 

  return data;
};

export function ProjectToJsonWithoutId(project: ProjectModel) {
  const data = {
    key: project.key,
    category: project.category.key,
    title: project.title,
    description: project.description,
    longDescription: project.longDescription,
    coverImage: project.coverImage,
    images: project.images,
    framework: project.framework.key,
    keywords: project.keywords,
    url: project.url,
    createdDate: project.createdDate,
    latestUpdate: project.latestUpdate,
    isDeactive: project.isDeactive,
  };
  return data;
}
